import { Controller, SwitchInput } from "@";
import type { Control, FieldValues } from "react-hook-form";
import {
  driverPermissionsLabels,
  driverPermissionsDescriptions,
  type DriverPermissionKey,
} from "../lib/permissions";

interface DriverPermissionsSectionProps {
  control: Control<FieldValues>;
}

const DriverPermissionsSection = ({
  control,
}: DriverPermissionsSectionProps) => (
  <div>
    <h3 className="mb-3 text-base font-semibold dark:text-gray-400">الصلاحيات</h3>
    <div className="flex flex-col gap-5">
      {(Object.keys(driverPermissionsLabels) as DriverPermissionKey[]).map(
        (key) => (
          <Controller
            key={key}
            control={control}
            name={`permissions.${key}`}
            render={({ field }) => (
              <SwitchInput
                isBordered
                description={driverPermissionsDescriptions[key]}
                font="text-base"
                label={driverPermissionsLabels[key]}
                checked={!!field.value}
                change={(v: boolean) => field.onChange(v)}
              />
            )}
          />
        ),
      )}
    </div>
  </div>
);

export default DriverPermissionsSection;
